import { CartUpdateEvent } from '@theme/events';

/**
 * A teeinblue a saját "Kosárba" gombjával közvetlenül a /cart/add.js-t hívja, ezért a téma nem értesül
 * a hozzáadásról, és a fejléc kosár ikon számlálója nem frissül. A teeinblue viszont a hozzáadás után
 * küld egy eseményt a document-en: erre lekérjük a kosarat, és elküldjük a téma saját cart:update eseményét.
 */
const TEEINBLUE_AFTER_CART_ADDED = 'teeinblue-event-after-cart-added';

/** Több egymás utáni hozzáadás (pl. kiegészítő termékek) esetén csak az utolsó után frissítünk. */
const DEBOUNCE_MS = 400;

/** @type {ReturnType<typeof setTimeout> | undefined} */
let timeout;

async function syncCart() {
  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) return;

    const cart = await response.json();

    document.dispatchEvent(
      new CartUpdateEvent(cart, 'teeinblue', {
        source: 'teeinblue',
        itemCount: cart.item_count,
      })
    );
  } catch (_) {
    // no-op
  }
}

document.addEventListener(TEEINBLUE_AFTER_CART_ADDED, () => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(syncCart, DEBOUNCE_MS);
});
